// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating_22f99f92 {
  z-index: 80;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0,0,0,0.24), 0 0 2px 0 rgba(0,0,0,0.12);
  border: 1px solid #d8dde3;
  border-radius: 0.333em;
  transition-timing-function: ease-in-out;
  transition-property: opacity;
}
.floating_22f99f92.flip_22f99f92 {
  box-shadow: 0 -2px 2px 0 rgba(0,0,0,0.24), 0 0 2px 0 rgba(0,0,0,0.12);
}
.floating_22f99f92.initial_22f99f92 {
  opacity: 0;
}
.floating_22f99f92.open_22f99f92 {
  transition-duration: 150ms;
}
.floating_22f99f92.close_22f99f92 {
  transition-duration: 150ms;
  opacity: 0;
}
.floating_22f99f92.unmounted_22f99f92 {
  display: none;
}
.floating_22f99f92 [data-overlayscrollbars-contents] {
  overscroll-behavior: contain;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"floating": `floating_22f99f92`,
	"flip": `flip_22f99f92`,
	"initial": `initial_22f99f92`,
	"open": `open_22f99f92`,
	"close": `close_22f99f92`,
	"unmounted": `unmounted_22f99f92`
};
export default ___CSS_LOADER_EXPORT___;
